import React from "react";
import "./Footer.scss"
import fb from "../../assets/icons/fb.svg"
import insta from "../../assets/icons/insta.svg"
import twitter from "../../assets/icons/twitter.svg"
import tripad from "../../assets/icons/tripad.svg"
import logo from "../../assets/logo.png"
import Button from "../Button/Button";
import MapLocationComponent from "./MapLocationComponent";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";


const Footer = () => {
    const history = useHistory()
    const isComingSoon = window.location.pathname === "/coming-soon"
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);
    const links = [
        {
            "Title": "Home",
            "Link": "/"
        }, {
            "Title": "Book A Table",
            "Link": "/"
        }, {
            "Title": "Menu",
            "Link": "/menu"
        }, {
            "Title": "Click & Collect",
            "Link": "/"
        }, {
            "Title": "The Restaurant",
            "Link": "/"
        },
    ]
    return (
        <div className="VirasatV2Default-Footer">
            {companyDetails?.settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.address?.lat}
                lng={companyDetails?.address?.lng}
            />}
            <div className="VirasatV2Default-Footer-top">
                <div className="VirasatV2Default-Footer-top-inner">
                    <div className="VirasatV2Default-Footer-top-inner-cont">
                        <div className="footer-VirasatV2Default-header-logo">
                            <div className="footer-VirasatV2Default-header-logo-cont">
                                <img alt="" className="footer-VirasatV2Default-header-logo-cont-img" src={logo} />
                            </div>
                            <div className="footer-VirasatV2Default-header-logo-namecont">
                                <div className="footer-VirasatV2Default-header-logo-namecont-title">
                                    Virasat
                                </div>
                                <div className="footer-VirasatV2Default-header-logo-namecont-sub">
                                    fine dining
                                </div>
                            </div>
                        </div>
                        <div className="footer-VirasatV2Default-subheader">
                            For a truly memorable dining experience, be sure to reserve your table in advance. Come and taste our remarkable food and wine.
                        </div>
                    </div>
                    {!isComingSoon && <div className="VirasatV2Default-Footer-top-inner-cont">
                        <div className="footer-VirasatV2Default-header">
                            QUICK LINKS
                        </div>
                        {links.map((link, key) => {
                            return (
                                <div className="footer-header-item" key={key}
                                    onClick={() => {
                                        history.push(link.Link)
                                    }}>
                                    {link.Title}
                                </div>
                            )
                        })}

                    </div>}
                    <div className="VirasatV2Default-Footer-top-inner-cont">
                        <div className="footer-VirasatV2Default-header">
                            ADDRESS
                        </div>
                        <div className="footer-header-item">
                            13-15, High Street, Staines-Upon-Thames, Surrey, TW18 4QY

                        </div>
                        <div className="margin-18" />
                        <div className="footer-header-item">
                            P:<b>+44 1784 463978</b>
                        </div>
                        <div className="footer-header-item">
                            E:<b> info@virasat.uk</b>
                        </div>
                    </div>
                    {!isComingSoon &&
                        <div className="VirasatV2Default-Footer-top-inner-cont">
                            <div className="footer-VirasatV2Default-header">
                                Get in touch
                            </div>
                            <div className="footer-header-item">
                                Get in touch with us for enquiries and collaborations.
                            </div>
                            <div className="footer-header-item-btn">
                                <Button
                                    text={"MAKE AN ENQUIRY"}
                                    onClick={() => {
                                        history.push("/contact")
                                    }} />
                            </div>

                        </div>}
                </div>
            </div>
            <div className="VirasatV2Default-Footer-bottom">
                <div className="VirasatV2Default-Footer-bottom-inner">
                    <div className="copy-right-text-footer-vi">2025 © Virasat. Designed & Powered by WITMEG</div>
                    <div className="footer-img-cont">
                        {company?.SocialMedias
                            ?.facebook && company?.SocialMedias
                                ?.facebook !== "" && <img alt="" src={fb} className="footer-img-cont-icon"
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.facebook, '_blank')
                                    }} />}
                        {company?.SocialMedias
                            ?.x && company?.SocialMedias
                                ?.x !== "" && <img alt="" src={twitter} className="footer-img-cont-icon"
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.x, '_blank')
                                    }} />}
                        {company?.SocialMedias
                            ?.instagram && company?.SocialMedias
                                ?.instagram !== "" && <img alt="" src={insta} className="footer-img-cont-icon"
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.instagram, '_blank')
                                    }} />}
                        {company?.SocialMedias
                            ?.tripAdvisor && company?.SocialMedias
                                ?.tripAdvisor !== "" && <img alt="" src={tripad}
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.tripAdvisor, '_blank')
                                    }} className="footer-img-cont-icon" />}


                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer